import { useQuery } from "@tanstack/react-query";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthProvider";

const MyAppointment = () => {
  const { user } = useContext(AuthContext);
  //   const user = "res";

  const url = `https://doctors-portal-server-azure.vercel.app/bookings?email=${user?.email}`;

  const { data: bookings = [] } = useQuery({
    queryKey: ["bookings", user?.email],
    queryFn: async () => {
      const res = await fetch(url, {
        headers: {
          authorization: "Bearer " + localStorage.getItem("doctors_token"),
        },
      });
      const data = await res.json();
      return data;
    },
  });
  console.log(bookings, url);

  return (
    <section className="">
      <main className=" bg-[#F1F5F9] px-14 py-7 min-h-screen">
        {/* My Apoointments header */}
        <div className="flex justify-between items-center py-7">
          <p className="text-lg font-medium">My Appointments</p>
          <button className="btn btn-outline">May 10,2022</button>
        </div>
        {/* Table */}
        <div className="overflow-x-auto relative shadow-md sm:rounded-lg ">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  <span className="sr-only">Index</span>
                </th>
                <th scope="col" className="py-3 px-6">
                  Name
                </th>
                <th scope="col" className="py-3 px-6">
                  Service
                </th>
                <th scope="col" className="py-3 px-6">
                  Date
                </th>
                <th scope="col" className="py-3 px-6">
                  Time
                </th>
                <th scope="col" className="py-3 px-6">
                  Payment
                </th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((book, index) => (
                <tr
                  key={book._id}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td className="py-4 px-6 text-right">{++index}</td>
                  <th
                    scope="row"
                    className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                  >
                    {book.patient}
                  </th>
                  <td className="py-4 px-6">{book.treatment}</td>
                  <td className="py-4 px-6">{book.appointmentDate}</td>
                  <td className="py-4 px-6">{book.slot}</td>
                  <td className="py-4 px-6">
                    {book.price && !book.paid && (
                      <Link to={`/dashboard/payment/${book._id}`}>
                        <button className="btn btn-primary btn-sm text-white">
                          PAY ${book.price}
                        </button>
                      </Link>
                    )}
                    {book.price && book.paid && (
                      <span className="text-emerald-600 border border-emerald-700 py-1 px-5 rounded-md">
                        Paid
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </section>
  );
};

export default MyAppointment;
